<script>
    import { navigate } from 'svelte-routing'
    import date from 'date-and-time'

    import { Mapper } from '../../middleware/model/taskmapper'
    import { Tasks } from '../../middleware/database/tasks'
    import { currentUser } from '../../stores/current_user'

    import Form from './form.svelte'

    const task = {
        agentId: '--NO-AGENT--',
        projectId: '--NO-PROJECT--',
        title: '',
        summary: '',
        description: '',
        state: 'OPEN',
        expire: null,
        geolocation: '',
        subtasks: [],
        createdAt: new Date(),
        createdBy: $currentUser.id,
        address: {
            address1: '',
            address2: '',
            postalCode: '',
            city: '',
            state: null,
            country: ''
        },
    }

    function saveTask(event) {

        let task = event.detail

        task.state = 'OPEN' // Forced. TODO: use static
        task.expire = (task.expire) ? date.parse(task.expire, 'YYYY-MM-DD') : null
        
        task.agentId = (task.agentId === 'null') ? null : task.agentId
        task.projectId = (task.projectId === 'null') ? null : task.projectId
        
        Tasks.add(Mapper, task)
            .then(ref => {
                navigate('/tasks')
            })
            .catch(err => {
                console.log(err)
            })

    }


</script>

<Form pageTitle="Create new task" {task} on:submit={saveTask} />
